// @ts-ignore Legacy JS module without declarations.
import { GET_SET_CFDI, GET_SET_COMPANY_TAX_INFO_CERTIFIES, GET_SET_COMPANY_TAX_INFO_v2 } from '../utils/api';
// @ts-ignore Legacy JS module without declarations.
import { getData, postData, putData } from '../utils/api-service';
import WashdayClientSingleton from './WashdayClientSingleton';
import type { CreateCFDIRequest } from 'washday-sdk';

type TranslateFn = (key: string) => string;

type SearchGlobalByPaymentMethodCandidatesPayload = {
  paymentMethod: 'cash' | 'card' | 'transfer' | 'mercadopago';
  dateFrom: string;
  dateTo: string;
  storeIds?: string[];
  includeAllStores?: boolean;
};

type GlobalByPaymentMethodCFDIPayload = {
  paymentMethod: 'cash' | 'card' | 'transfer' | 'mercadopago';
  date: string;
  sendEmailInvoice?: boolean;
  global?: {
    periodicity: string;
    months: string;
    year: string;
  };
  paymentLines: Array<{
    paymentLineId: string;
    description: string;
  }>;
  dateFrom?: string;
  dateTo?: string;
  storeIds?: string[];
  includeAllStores?: boolean;
};

export type GlobalPaymentMethodPayload =
  | SearchGlobalByPaymentMethodCandidatesPayload
  | GlobalByPaymentMethodCFDIPayload;

export const getInvoicesByCompany = async (
  _storeId: string | undefined,
  query: string,
  _t: TranslateFn = () => ''
) => {
  try {
    let res = await getData(`${GET_SET_CFDI}?${query}`);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return [];
  }
};

export const updateCompanyTaxInfo = async (
  companyId: string,
  putObj: FormData | Record<string, unknown>,
  t: TranslateFn
) => {
  try {
    const res = await putData(
      GET_SET_COMPANY_TAX_INFO_v2(companyId),
      putObj,
      false,
      t('alerts.success'),
      'multipart/form-data',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const updateCompanyCertifies = async (
  companyId: string,
  putObj: FormData | Record<string, unknown>,
  t: TranslateFn
) => {
  try {
    console.log('putObj', putObj);
    const res = await postData(
      GET_SET_COMPANY_TAX_INFO_CERTIFIES(companyId),
      putObj,
      false,
      t('alerts.success'),
      'multipart/form-data',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const updateCFDIOrgLogo = async (
  companyID: string,
  putObj: FormData | Record<string, unknown>,
  t: TranslateFn = () => ''
) => {
  try {
    console.log('putObj', putObj);
    const res = await postData(
      `api/company/${companyID}/taxInfo/logo`,
      putObj,
      false,
      t('alerts.success'),
      'multipart/form-data',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico', e);
    throw e;
  }
};

export const downloadInvoicePDF = async (
  invoiceID: string,
  fileName: string,
  t: TranslateFn = () => ''
) => {
  const res = await getData(
    `${GET_SET_CFDI}/${invoiceID}/download/pdf`,
    null,
    t,
    'multipart/form-data',
    'arraybuffer',
    `attachment; filename=[${fileName}.pdf]`
  );
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}_${new Date().toISOString()}.pdf`);
  document.body.appendChild(link);
  link.click();
};

export const sendInvoiceEmail = async (invoiceID: string, t: TranslateFn = () => '') => {
  try {
    let res = await getData(`${GET_SET_CFDI}/${invoiceID}/email`, null, t);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const getGlobalCFDIPreview = async (
  ordersID: string,
  customerID = '',
  t: TranslateFn = () => ''
) => {
  try {
    let query = `ordersID=${ordersID}`;
    if (customerID) {
      query += `&customer=${customerID}`;
    }
    let res = await getData(`${GET_SET_CFDI}/global/preview?${query}`, null, t);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const createGlobalCFDI = async (
  values: Record<string, unknown>,
  t: TranslateFn = () => ''
) => {
  try {
    const res = await postData(
      `${GET_SET_CFDI}/global`,
      values,
      null,
      t('alerts.success'),
      null,
      t
    );
    return {
      status: true,
      res
    };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return {
      status: false,
      res: e
    };
  }
};


export const getCFDIPreviewV2 = async (params: {
  ordersID?: string[];
  customer?: string
}) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== undefined)
  );
  return WashdayClientSingleton.getInstance().invoiceModule.getCFDIPreview(filteredParams);
};

export const createCFDI = async (data: CreateCFDIRequest) => {
  const filteredParams = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  );
  return WashdayClientSingleton.getInstance().invoiceModule.createCFDI(filteredParams);
};

export const cancelCFDIInvoiceV2 = async (id: string, data: {
  motive: string
  substitution?: string
}) => {
  return WashdayClientSingleton.getInstance().invoiceModule.cancelCFDI(id, data);
};


export const getCFDIListV2 = async (params: {
  query?: string;
  storeId?: string;
  fromDate?: string;
  toDate?: string;
  limit?: string;
  pageNum?: string;
}) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== undefined)
  );
  return WashdayClientSingleton.getInstance().invoiceModule.getCFDIList(filteredParams);
};

export const downloadCFDIPDFV2 = async (id: string) => {
  return WashdayClientSingleton.getInstance().invoiceModule.downloadCFDIPDF(id);
};

export const downloadCFDIZIP = async (id: string) => {
  return WashdayClientSingleton.getInstance().invoiceModule.downloadCFDIZIP(id);
};

export const sendCFDIByEmailV2 = async (id: string) => {
  return WashdayClientSingleton.getInstance().invoiceModule.sendCFDIByEmail(id);
};

export const searchGlobalByPaymentMethodCandidates = async (
  data: SearchGlobalByPaymentMethodCandidatesPayload
) => {
  const filteredParams = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  ) as SearchGlobalByPaymentMethodCandidatesPayload;

  return WashdayClientSingleton.getInstance().invoiceModule.searchGlobalByPaymentMethodCandidates(
    filteredParams
  );
};

export const previewGlobalByPaymentMethodCFDI = async (
  data: GlobalByPaymentMethodCFDIPayload
) => {
  const filteredParams = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  ) as GlobalByPaymentMethodCFDIPayload;

  return WashdayClientSingleton.getInstance().invoiceModule.previewGlobalByPaymentMethodCFDI(
    filteredParams
  );
};

export const createGlobalByPaymentMethodCFDI = async (
  data: GlobalByPaymentMethodCFDIPayload
) => {
  const filteredParams = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  ) as GlobalByPaymentMethodCFDIPayload;

  return WashdayClientSingleton.getInstance().invoiceModule.createGlobalByPaymentMethodCFDI(
    filteredParams
  );
};
